// extracted by mini-css-extract-plugin
export default {"stickySide":"Profile_stickySide__u2pLD","placeHolderShimmer":"Profile_placeHolderShimmer__xmcUY"};